import React from "react";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TablePagination,
  Typography,
} from "@mui/material";

import { Client } from "../../../types";
import AdminClientsTableRow from "./admin-clients-table-row";

type AdminClientsTableProps = {
  clients: Client[];
  clientsLoading?: boolean;
  selectedClientId?: string;
  onSelectClient?: (client: Client) => void;
  sortBy: string;
  sortOrder: "asc" | "desc";
  onSort: (field: string) => void;
  currentPage: number;
  rowsPerPage: number;
  onPageChange: (page: number) => void;
};

const AdminClientsTable: React.FC<AdminClientsTableProps> = ({
  clients,
  clientsLoading = false,
  selectedClientId,
  onSelectClient,
  sortBy,
  sortOrder,
  onSort,
  currentPage,
  rowsPerPage,
  onPageChange,
}) => {
  const paginatedClients = clients.slice(
    currentPage * rowsPerPage,
    currentPage * rowsPerPage + rowsPerPage,
  );

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell sx={{ py: 0.5, whiteSpace: "nowrap" }}>
              <TableSortLabel
                active={sortBy === "clientName"}
                direction={sortBy === "clientName" ? sortOrder : "asc"}
                onClick={() => onSort("clientName")}
                sx={{ fontSize: "0.875rem" }}
              >
                Client Name
              </TableSortLabel>
            </TableCell>
            <TableCell sx={{ py: 0.5, fontSize: "0.875rem", whiteSpace: "nowrap" }}>
              Status
            </TableCell>
            <TableCell sx={{ py: 0.5, fontSize: "0.875rem", whiteSpace: "nowrap" }}>
              Created
            </TableCell>
            <TableCell sx={{ py: 0.5, fontSize: "0.875rem", width: "100%" }}>
              Client Administrators
            </TableCell>
            <TableCell
              align="right"
              sx={{ py: 0.5, fontSize: "0.875rem", whiteSpace: "nowrap" }}
            >
              Actions
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {clientsLoading ? (
            <TableRow>
              <TableCell colSpan={5} align="center">
                <Typography>Loading...</Typography>
              </TableCell>
            </TableRow>
          ) : clients.length === 0 ? (
            <TableRow>
              <TableCell colSpan={5} align="center">
                <Typography color="text.secondary">No clients found</Typography>
              </TableCell>
            </TableRow>
          ) : (
            paginatedClients.map((client) => (
              <AdminClientsTableRow
                key={client.clientId}
                client={client}
                onSelect={onSelectClient}
                selected={selectedClientId === client.clientId}
              />
            ))
          )}
        </TableBody>
      </Table>
      <TablePagination
        component="div"
        count={clients.length}
        page={currentPage}
        onPageChange={(_, nextPage) => onPageChange(nextPage)}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={[rowsPerPage]}
      />
    </TableContainer>
  );
};

export default AdminClientsTable;